import { Divider, Row, Col, Avatar, Card } from 'antd';
import { useAuth } from "../../../Components/ProtectedRoute/ProtectedRoute"
import VehicleSaleReport from "./SaleReport";
import GuageForFix from "./GuageForFix";
import SecondSaleReport from './SecondSaleReport';
import ProfitPercentage from './ProfitPercentage'

function DashBoard() {
    const auth = useAuth()
    return(
        <div>
            <Row align="middle">
                <Col span={6}>
                    <Avatar 
                        size={{xs: 24, sm: 32,md: 40,lg: 64,xl: 150,xxl: 300,}}
                        src={auth.employeePhoto} 
                        alt={auth.user} 
                    />
                </Col>
                <Col span={12}>
                    <h1>Welcome Back, {auth.user}</h1>
                </Col>
            </Row>

            <Divider orientation="left" style={{fontSize:'32px'}}>
                Dash Board
            </Divider>
                <Card>
                    <h4>Sales Report</h4>
                    <VehicleSaleReport style={{ minHeight: '10vh' }}/>
                </Card>
            <Divider />
            <Row gutter={[16, 16]}>
                    <Col span={8}>
                        <Card>
                            <h5>Percentage of Car Inventory For Sale</h5>
                            <GuageForFix  />
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card>
                            <h5>Vehicles Sold by Model</h5>
                            <SecondSaleReport />
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card>
                            <h5>Profit Margin by Model</h5>
                            <ProfitPercentage />
                        </Card>
                    </Col>
            </Row>

        </div>
    )
}


export default DashBoard